export const initializeAnalytics = async () => {
	if (process.env.NODE_ENV !== "production") return;

	if (!process.env.REACT_APP_POSTHOG_APP_ID) return;

	const { default: posthog } = await import("posthog-js");
	posthog.init(process.env.REACT_APP_POSTHOG_APP_ID, {
		persistence: "localStorage",
		autocapture: true,
		capture_pageview: true,
		capture_pageleave: true,
	});
};
